import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Stack,
  IconButton,
  List,
  ListItem,
  TextField,
  Button
} from '@mui/material';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import { LinkedIn, Twitter, GitHub, KeyboardArrowUp } from '@mui/icons-material';
import darkLogo from '../../assets/logo/logo_dark.png';
import lightLogo from '../../assets/logo/logo_light.png';

// ScrollTop component (needs to be defined or imported)
const ScrollTop = ({ children }) => {
  return children;
};


const Footer = ({ mode }) => {
    return (
      <>
        <Box
          sx={{
            py: 6,
            bgcolor: mode === 'dark' ? 'rgba(10, 10, 26, 0.8)' : 'rgba(245, 247, 255, 0.8)',
            backdropFilter: 'blur(12px)',
            borderTop: mode === 'dark' ? '1px solid rgba(106, 27, 255, 0.1)' : '1px solid rgba(94, 0, 255, 0.05)',
          }}
        >
          <Container maxWidth="xl">
            <Grid container spacing={6}>
              <Grid item xs={12} md={6}>
                <Box sx={{ mb: 2 }}>
                  <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                    {/* {mode === 'dark' ? <SoranovaDarkLogo /> : <SoranovaLightLogo />} */}
                    <img src={mode === 'dark' ? darkLogo : lightLogo} alt="Logo" style={{ height: '60px' }} />
                  </Link>
                </Box>
                <Typography variant="body1" color="text.secondary" paragraph>
                  Transforming businesses through innovative technology solutions and digital excellence.
                </Typography>
                <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
                  <IconButton
                    aria-label="LinkedIn"
                    href="https://www.linkedin.com/company/soranova"
                    target="_blank"
                    sx={{
                      bgcolor: mode === 'dark' ? 'rgba(106, 27, 255, 0.1)' : 'rgba(94, 0, 255, 0.05)',
                      color: mode === 'dark' ? '#9a4dff' : '#5e00ff',
                      '&:hover': {
                        bgcolor: mode === 'dark' ? 'rgba(106, 27, 255, 0.2)' : 'rgba(94, 0, 255, 0.1)',
                      },
                    }}
                  >
                    <LinkedIn />
                  </IconButton>
                  {/* <IconButton
                    aria-label="Twitter"
                    href="https://twitter.com"
                    target="_blank"
                    sx={{
                      bgcolor: mode === 'dark' ? 'rgba(0, 229, 255, 0.1)' : 'rgba(0, 229, 255, 0.05)',
                      color: mode === 'dark' ? '#66ffff' : '#00b2cc',
                      '&:hover': {
                        bgcolor: mode === 'dark' ? 'rgba(0, 229, 255, 0.2)' : 'rgba(0, 229, 255, 0.1)',
                      },
                    }}
                  >
                    <Twitter />
                  </IconButton>
                  <IconButton
                    aria-label="GitHub"
                    href="https://github.com"
                    target="_blank"
                    sx={{
                      bgcolor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                      color: 'text.primary',
                      '&:hover': {
                        bgcolor: mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <GitHub />
                  </IconButton> */}
                </Stack>
                <Typography variant="body2" color="text.secondary">
                  © {new Date().getFullYear()} Soranova Technologies Pvt Ltd. All rights reserved.
                </Typography>
              </Grid>
              {/* <Grid item xs={6} md={2}>
                <Typography variant="h6" component="h4" gutterBottom>
                  Company
                </Typography>
                <List dense>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/about"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      About Us
                    </MuiLink>
                  </ListItem>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/about#team"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Our Team
                    </MuiLink>
                  </ListItem>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/about#careers"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Careers
                    </MuiLink>
                  </ListItem>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/about#partners"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Partners
                    </MuiLink>
                  </ListItem>
                </List>
              </Grid> */}
              {/* <Grid item xs={6} md={6}>
                <Typography variant="h6" component="h4" gutterBottom>
                  Solutions
                </Typography>
                <List dense>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/solutions#enterprise"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Enterprise
                    </MuiLink>
                  </ListItem>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/solutions#startups"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Startups
                    </MuiLink>
                  </ListItem>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/solutions#government"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Government
                    </MuiLink>
                  </ListItem>
                  <ListItem disablePadding>
                    <MuiLink
                      component={Link}
                      to="/solutions#education"
                      color="text.secondary"
                      underline="none"
                      sx={{
                        py: 0.5,
                        '&:hover': {
                          color: 'primary.main',
                        },
                      }}
                    >
                      Education
                    </MuiLink>
                  </ListItem>
                </List>
              </Grid> */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" component="h4" gutterBottom>
                  Newsletter
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                  Subscribe to our newsletter for the latest updates and insights.
                </Typography>
                <Stack direction="row" spacing={1}>
                  <TextField
                    placeholder="Your email"
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                        },
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    Subscribe
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Scroll to top button */}
        {/* <ScrollTop>
          <Button
            variant="contained"
            color="primary"
            sx={{
              minWidth: 0,
              width: 50,
              height: 50,
              borderRadius: '50%',
              p: 0,
              boxShadow: mode === 'dark'
                ? '0 4px 20px 0 rgba(106, 27, 255, 0.4)'
                : '0 4px 20px 0 rgba(94, 0, 255, 0.2)',
            }}
            aria-label="scroll back to top"
          >
            <KeyboardArrowUp />
          </Button>
        </ScrollTop> */}
      </>
    );
};

export default Footer;